import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchCampaignList = (parameters) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/campaing/query${getUrlParameters(parameters)}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CAMPAIGNS_LIST,
        ActionTypes.FETCHED_CAMPAIGNS_LIST,
        [
          ActionTypes.FETCHED_CAMPAIGNS_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const clearCampaignsList = () => {
  return {
    'type': ActionTypes.CLEAR_CAMPAIGNS_LIST,
  };
};
